var _adapter, _lastMessageId, _pendingMessages, _pendingCallbacks, _savePendingMessage, _sendPendingMessages;

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }

var id = 0;

function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

/*
Strada 1.0.0-beta1
Copyright © 2023 37signals LLC
*/
var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);

  return value;
}; // src/bridge.js


var Bridge = (_adapter = /*#__PURE__*/_classPrivateFieldLooseKey("adapter"), _lastMessageId = /*#__PURE__*/_classPrivateFieldLooseKey("lastMessageId"), _pendingMessages = /*#__PURE__*/_classPrivateFieldLooseKey("pendingMessages"), _pendingCallbacks = /*#__PURE__*/_classPrivateFieldLooseKey("pendingCallbacks"), _savePendingMessage = /*#__PURE__*/_classPrivateFieldLooseKey("savePendingMessage"), _sendPendingMessages = /*#__PURE__*/_classPrivateFieldLooseKey("sendPendingMessages"), /*#__PURE__*/function () {
  function Bridge() {
    _classCallCheck(this, Bridge);

    Object.defineProperty(this, _sendPendingMessages, {
      value: _sendPendingMessages2
    });
    Object.defineProperty(this, _savePendingMessage, {
      value: _savePendingMessage2
    });
    Object.defineProperty(this, _adapter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _lastMessageId, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _pendingMessages, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _pendingCallbacks, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _adapter)[_adapter] = null;
    _classPrivateFieldLooseBase(this, _lastMessageId)[_lastMessageId] = 0;
    _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages] = [];
    _classPrivateFieldLooseBase(this, _pendingCallbacks)[_pendingCallbacks] = /* @__PURE__ */new Map();
  }

  _createClass(Bridge, [{
    key: "start",
    value: function start() {
      this.notifyApplicationAfterStart();
    }
  }, {
    key: "notifyApplicationAfterStart",
    value: function notifyApplicationAfterStart() {
      document.dispatchEvent(new Event("web-bridge:ready"));
    }
  }, {
    key: "supportsComponent",
    value: function supportsComponent(component) {
      if (_classPrivateFieldLooseBase(this, _adapter)[_adapter]) {
        return _classPrivateFieldLooseBase(this, _adapter)[_adapter].supportsComponent(component);
      } else {
        return false;
      }
    }
  }, {
    key: "send",
    value: function send(_ref) {
      var component = _ref.component,
          event = _ref.event,
          data = _ref.data,
          callback = _ref.callback;

      if (!_classPrivateFieldLooseBase(this, _adapter)[_adapter]) {
        _classPrivateFieldLooseBase(this, _savePendingMessage)[_savePendingMessage]({
          component: component,
          event: event,
          data: data,
          callback: callback
        });

        return null;
      }

      if (!this.supportsComponent(component)) return null;
      var id = this.generateMessageId();
      var message = {
        id: id,
        component: component,
        event: event,
        data: data || {}
      };

      _classPrivateFieldLooseBase(this, _adapter)[_adapter].receive(message);

      if (callback) {
        _classPrivateFieldLooseBase(this, _pendingCallbacks)[_pendingCallbacks].set(id, callback);
      }

      return id;
    }
  }, {
    key: "receive",
    value: function receive(message) {
      this.executeCallbackFor(message);
    }
  }, {
    key: "executeCallbackFor",
    value: function executeCallbackFor(message) {
      var callback = _classPrivateFieldLooseBase(this, _pendingCallbacks)[_pendingCallbacks].get(message.id);

      if (callback) {
        callback(message);
      }
    }
  }, {
    key: "removeCallbackFor",
    value: function removeCallbackFor(messageId) {
      if (_classPrivateFieldLooseBase(this, _pendingCallbacks)[_pendingCallbacks].has(messageId)) {
        _classPrivateFieldLooseBase(this, _pendingCallbacks)[_pendingCallbacks].delete(messageId);
      }
    }
  }, {
    key: "removePendingMessagesFor",
    value: function removePendingMessagesFor(component) {
      _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages] = _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages].filter(function (message) {
        return message.component != component;
      });
    }
  }, {
    key: "generateMessageId",
    value: function generateMessageId() {
      var id = ++_classPrivateFieldLooseBase(this, _lastMessageId)[_lastMessageId];
      return id.toString();
    }
  }, {
    key: "setAdapter",
    value: function setAdapter(adapter) {
      _classPrivateFieldLooseBase(this, _adapter)[_adapter] = adapter;
      document.documentElement.dataset.bridgePlatform = _classPrivateFieldLooseBase(this, _adapter)[_adapter].platform;
      this.adapterDidUpdateSupportedComponents();

      _classPrivateFieldLooseBase(this, _sendPendingMessages)[_sendPendingMessages]();
    }
  }, {
    key: "adapterDidUpdateSupportedComponents",
    value: function adapterDidUpdateSupportedComponents() {
      if (_classPrivateFieldLooseBase(this, _adapter)[_adapter]) {
        document.documentElement.dataset.bridgeComponents = _classPrivateFieldLooseBase(this, _adapter)[_adapter].supportedComponents.join(" ");
      }
    }
  }]);

  return Bridge;
}()); // src/bridge_component.js

function _savePendingMessage2(message) {
  _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages].push(message);
}

function _sendPendingMessages2() {
  var _this3 = this;

  _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages].forEach(function (message) {
    return _this3.send(message);
  });

  _classPrivateFieldLooseBase(this, _pendingMessages)[_pendingMessages] = [];
}

import { Controller } from "@hotwired/stimulus"; // src/bridge_element.js

var BridgeElement = /*#__PURE__*/function () {
  function BridgeElement(element) {
    _classCallCheck(this, BridgeElement);

    this.element = element;
  }

  _createClass(BridgeElement, [{
    key: "title",
    get: function get() {
      return (this.bridgeAttribute("title") || this.attribute("aria-label") || this.element.textContent || this.element.value).trim();
    }
  }, {
    key: "enabled",
    get: function get() {
      return !this.disabled;
    }
  }, {
    key: "disabled",
    get: function get() {
      var disabled = this.bridgeAttribute("disabled");
      return disabled === "true" || disabled === this.platform;
    }
  }, {
    key: "enableForComponent",
    value: function enableForComponent(component) {
      if (component.enabled) {
        this.removeBridgeAttribute("disabled");
      }
    }
  }, {
    key: "hasClass",
    value: function hasClass(className) {
      return this.element.classList.contains(className);
    }
  }, {
    key: "attribute",
    value: function attribute(name) {
      return this.element.getAttribute(name);
    }
  }, {
    key: "bridgeAttribute",
    value: function bridgeAttribute(name) {
      return this.attribute("data-bridge-".concat(name));
    }
  }, {
    key: "setBridgeAttribute",
    value: function setBridgeAttribute(name, value) {
      this.element.setAttribute("data-bridge-".concat(name), value);
    }
  }, {
    key: "removeBridgeAttribute",
    value: function removeBridgeAttribute(name) {
      this.element.removeAttribute("data-bridge-".concat(name));
    }
  }, {
    key: "click",
    value: function click() {
      if (this.platform == "android") {
        this.element.removeAttribute("target");
      }

      this.element.click();
    }
  }, {
    key: "platform",
    get: function get() {
      return document.documentElement.dataset.bridgePlatform;
    }
  }]);

  return BridgeElement;
}(); // src/helpers/user_agent.js


var userAgent = window.navigator.userAgent;
var isStradaNativeApp = /bridge-components: \[.+\]/.test(userAgent); // src/bridge_component.js

var BridgeComponent = /*#__PURE__*/function (_Controller) {
  _inherits(BridgeComponent, _Controller);

  var _super = _createSuper(BridgeComponent);

  function BridgeComponent() {
    var _this;

    _classCallCheck(this, BridgeComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.pendingMessageCallbacks = [];
    return _this;
  }

  _createClass(BridgeComponent, [{
    key: "initialize",
    value: function initialize() {
      this.pendingMessageCallbacks = [];
    }
  }, {
    key: "connect",
    value: function connect() {}
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.removePendingCallbacks();
      this.removePendingMessages();
    }
  }, {
    key: "component",
    get: function get() {
      return this.constructor.component;
    }
  }, {
    key: "platformOptingOut",
    get: function get() {
      var bridgePlatform = document.documentElement.dataset.bridgePlatform;
      return this.identifier == this.element.getAttribute("data-controller-optout-".concat(bridgePlatform));
    }
  }, {
    key: "enabled",
    get: function get() {
      return !this.platformOptingOut && this.bridge.supportsComponent(this.component);
    }
  }, {
    key: "send",
    value: function send(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      data.metadata = {
        url: window.location.href
      };
      var message = {
        component: this.component,
        event: event,
        data: data,
        callback: callback
      };
      var messageId = this.bridge.send(message);

      if (callback) {
        this.pendingMessageCallbacks.push(messageId);
      }
    }
  }, {
    key: "removePendingCallbacks",
    value: function removePendingCallbacks() {
      var _this2 = this;

      this.pendingMessageCallbacks.forEach(function (messageId) {
        return _this2.bridge.removeCallbackFor(messageId);
      });
    }
  }, {
    key: "removePendingMessages",
    value: function removePendingMessages() {
      this.bridge.removePendingMessagesFor(this.component);
    }
  }, {
    key: "bridgeElement",
    get: function get() {
      return new BridgeElement(this.element);
    }
  }, {
    key: "bridge",
    get: function get() {
      return window.Strada.web;
    }
  }], [{
    key: "shouldLoad",
    get: function get() {
      return isStradaNativeApp;
    }
  }]);

  return BridgeComponent;
}(Controller);

__publicField(BridgeComponent, "component", ""); // src/index.js


if (!window.Strada) {
  var webBridge = new Bridge();
  window.Strada = {
    web: webBridge
  };
  webBridge.start();
}

export { BridgeComponent, BridgeElement };